"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleRegionSpec = exports.VehicleWarrantyYearType = exports.VehicleStatusType = exports.VehicleMediaType = void 0;
var VehicleMediaType;
(function (VehicleMediaType) {
    VehicleMediaType["IMAGE"] = "image";
    VehicleMediaType["VIDEO"] = "video";
})(VehicleMediaType = exports.VehicleMediaType || (exports.VehicleMediaType = {}));
var VehicleStatusType;
(function (VehicleStatusType) {
    VehicleStatusType["RESERVED"] = "Reserved";
    VehicleStatusType["DRAFT"] = "Draft";
    VehicleStatusType["PUBLISHED"] = "Published";
    VehicleStatusType["SELF_RESERVED"] = "Self-Reserved";
    VehicleStatusType["SOLD"] = "Sold";
    VehicleStatusType["UNPUBLISHED"] = "Unpublished";
})(VehicleStatusType = exports.VehicleStatusType || (exports.VehicleStatusType = {}));
var VehicleWarrantyYearType;
(function (VehicleWarrantyYearType) {
    VehicleWarrantyYearType["NOT_AVAILABLE"] = "Not Available";
    VehicleWarrantyYearType["ONE_YEAR"] = "1 Year";
    VehicleWarrantyYearType["TWO_YEARS"] = "2 Years";
    VehicleWarrantyYearType["THREE_YEARS"] = "3 Years";
    VehicleWarrantyYearType["FOUR_YEARS"] = "4 Years";
    VehicleWarrantyYearType["FIVE_YEARS"] = "5 Years";
    VehicleWarrantyYearType["SIX_YEARS"] = "6 Years";
    VehicleWarrantyYearType["SEVEN_YEARS"] = "7 Years";
    VehicleWarrantyYearType["EIGHT_YEARS"] = "8 Years";
    VehicleWarrantyYearType["NINE_YEARS"] = "9 Years";
    VehicleWarrantyYearType["TEN_YEARS"] = "10 Years";
    VehicleWarrantyYearType["ELEVEN_YEARS"] = "11 Years";
    VehicleWarrantyYearType["TWELVE_YEARS"] = "12 Years";
    VehicleWarrantyYearType["THIRTEEN_YEARS"] = "13 Years";
    VehicleWarrantyYearType["FOURTEEN_YEARS"] = "14 Years";
    VehicleWarrantyYearType["FIFTEEN_YEARS"] = "15 Years";
})(VehicleWarrantyYearType = exports.VehicleWarrantyYearType || (exports.VehicleWarrantyYearType = {}));
var VehicleRegionSpec;
(function (VehicleRegionSpec) {
    VehicleRegionSpec["GCC_SPECS"] = "GCC specs";
    VehicleRegionSpec["CHINESE_SPECS"] = "Chinese specs";
    VehicleRegionSpec["EUROPEAN_SPECS"] = "European specs";
    VehicleRegionSpec["JAPANESE_SPECS"] = "Japanese specs";
    VehicleRegionSpec["USA_SPECS"] = "USA specs";
    VehicleRegionSpec["IMPORTED_SPECS"] = "Imported";
    VehicleRegionSpec["OTHER_SPECS"] = "Other specs";
})(VehicleRegionSpec = exports.VehicleRegionSpec || (exports.VehicleRegionSpec = {}));
